import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cfg from './config';
import vuei18n from 'vue-i18n'
import utils from "./utils"
import api from './utils/api'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(vuei18n);
Vue.prototype.$config = cfg;
Vue.prototype.$utils = utils;
Vue.prototype.$api = api;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');


/**初始化 */
function initApp() {
  /**设置title */
  document.title = cfg.title;
};

initApp();


